import React, { Component } from 'react';
import injectsheet from 'react-jss'
import {
    Row,
    Col,
} from 'reactstrap';

const styles={
    result:{
        marginTop: '3%',
        width: '80%',
        marginLeft: '10%',
        '@media screen and (max-width: 767px)':{
            width: '90%',
            marginLeft: '5%',
        },
        '& .title':{
            width: '100%',
            '& h2':{
                textAlign: 'left',
                color: '#ea9044',
                position: 'relative',
                display: 'inline-block',
                marginLeft: '2%',
                borderBottom: '2px solid #91230c',
                '@media screen and (max-width: 767px)':{
                    fontSize: '1.6rem',
                },
            },

        },
        '& .borderTop':{
            marginTop: '3%',
            marginBottom: '3%',
            paddingTop: '3%',
            paddingBottom: '3%',
            // boxShadow:'0px 0px  3px 3px #C0C0C0',
            margin: '0 auto',
            // borderRadius: '30px',
        },
        '& .borderWrapper':{
            marginBottom: '2%',
            paddingLeft: '2%',
            paddingRight: '2%',
            '@media screen and (max-width: 767px)':{
                boxShadow: '2px 1px 5px 1px #C0C0C0',
            },
            '& .col-md-10':{
                boxShadow: '2px 1px 5px 1px #C0C0C0',
                borderRadius: '20px',
                '@media screen and (max-width: 767px)':{
                    boxShadow: 'none',
                    borderRadius: '0',
                    
                },
            },
            '& img':{
                borderRadius: '80px',
                '@media screen and (max-width: 767px)':{
                    paddingTop:'3%',
                    width: '40%',
                    borderRadius: '50%',
                },
            },
            '& h5':{
                textAlign: 'left',
                color: '#91230c',
                marginTop: '3%',
                fontFamily: '-webkit-body',
                '@media screen and (max-width: 767px)':{
                    textAlign: 'center',
                },
            },
            '& p':{
                textAlign: 'justify',
                fontStyle: 'oblique',
                '@media screen and (max-width: 767px)':{
                    fontSize: '0.9rem',
                    paddingLeft: '2%',
                    paddingRight: '2%',
                },
            }
        }
    }
}

class Result extends Component {
  render() {
      const { classes } = this.props
    return (
            <div className={classes.result}>
                <div className="title">
                    <h2>Testimonial</h2>
                </div>
                <Row className="borderTop">
                   <div className="borderWrapper">
                        <Row>
                            <Col md="2">
                                <img  src="/images/VIPIN_SINGH.jpg" width="100%" alt="VIPIN_SINGH + 'JRF Coaching Ranchi'+"/>
                            </Col>
                            <Col md="10">
                                <h5>Vipin Singh, JRF/NET (CSIR)</h5>
                                <p>Vidyayatan helps to culture and gain a thorough knowledge focusing on the units, important for the various National level Exams. The weekly tests and unit test helps in understandind the pattern on which we need to focus on more and the time management as well. This institute acts as a good source of advice and guidence through that journey.....</p>
                            </Col>
                        </Row>
                   </div>
                   <div className="borderWrapper">
                        <Row>
                            <Col md="2">
                                <img  src="/images/PRITY1.jpg" width="100%" alt="PRITY1"/>
                            </Col>
                            <Col md="10">
                            <h5>Priti Kumari Oraon, JRF/NET (CSIR)</h5>
                                <p>I joined Vidyayatan NET classes and I am extremely glad that I have chosen it. Our sir is knowledgeable, experienced and self-motivated mentor who helped us in every little bits to mastering the concepts. His classes were always enjoyable. He spends extra time for our doubts and his study metrial is highly helpful, Test series were also challenging and gave us a look through of real NET papers.....
                                </p>
                            </Col>
                        </Row>
                   </div>
                   <div className="borderWrapper">
                        <Row>
                            <Col md="2">
                                <img  src="/images/RANJAN_K_BHAGAT.jpg" width="100%" alt="RANJAN_K_BHAGAT"/>
                            </Col>
                            <Col md="10">
                            <h5>Ranjan Kr. Bhagat, JRF/NET (CSIR)</h5>
                                <p> Success occurs when opportunity meets preparation and Vidyaratan helped me with massive success. It has Made me a different person who is more confident and ready to step into a very big world of knowledge out there. I would like to thank our sir because he is the key of my success..... </p>
                            </Col>
                        </Row>
                   </div>
                   <div className="borderWrapper">
                        <Row>
                            <Col md="2">
                                <img  src="/images/KANIKA.jpg" width="100%" alt="KANIKA"/>
                            </Col>
                            <Col md="10">
                            <h5>Kanika Kumari, JRF/NET (CSIR)</h5>
                                <p> Vidyayatan institue is the best institute for the preparation of NET ( Life Sciences ). Sir is so motivational, entertaining and the person who is full of knowledge. He makes the concept easier which is difficult and his straegies of teaching and mode of explanation is fabulous..... </p>
                            </Col>
                        </Row>
                   </div>
                </Row>
            </div>
      
    );
  }
}

export default injectsheet(styles) (Result);
